import Vue from 'vue'
import { lsGet, lsSet, setRefer, getRefer } from '@/utils/ls'

const $ls = {
    get(key) {
        return lsGet(key)
    },

    set(key, value) {
        return lsSet(key, value)
    },

    setRefer,

    getRefer,
}

Vue.mixin({
    data() {
        return {
            // 是否开发模式
            isDev: process.env.NODE_ENV === 'development'
        }
    },

    beforeCreate() {
        // localStorage存储对象
        this.$ls = $ls
    },
})